import { supportedLocales } from "@cronika/locales";

const localePattern = new RegExp(`^/(?:${supportedLocales.join("|")})(?=/|$)`);

export function getCleanPathname(pathname: string): string {
  return pathname.replace(localePattern, "") || "/";
}
